
<div class="cbar">
  <div class="ms-CommandBar">
    <div class="ms-CommandBar-mainArea">
      <div class="ms-CommandButton">
        <button
          (click)="abrirModalCrear()"
          class="ms-CommandButton-button"
          type="button"
        >
          <span class="ms-CommandButton-icon ms-fontColor-themePrimary"
            ><i class="ms-Icon ms-Icon--CalculatorAddition"></i
          ></span>
          <span class="ms-CommandButton-label">Nuevo</span>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="pageContent">
  <div class="pageTitle">
    <h2>Usuarios</h2>
  </div>
  <app-data-table
    tableId="datatableUsuarios"
    [serverSide]="true"
    [serverData]="getDataTableUsuario"
    [columns]="columnas"
    (loadedGrid)="gridLoaded($event)"
    (custom)="customClick($event)"
    [buttonsOptions]="dtOptButtons"
  ></app-data-table>
</div>

<!-- Nuevo -->
<div class="docs-DialogExample-lgHeader">
  <div class="ms-Dialog ms-Dialog--lgHeader create-usuarios" appPreventOutsideClick>
    <div id="dialogCreateEdit" class="ms-Dialog-title">Crear Usuario</div>
    <form
      [formGroup]="userForm"
      (ngSubmit)="crearEditarUsuario()"
      name="userForm"
    >
      <div class="ms-Dialog-content input-grid form-group">
        <div>
          <app-text-box
            [frm]="userForm"
            formControlName="Email"
            type="email"
            [required]="true"
            label="Correo electrónico"
          ></app-text-box>
        </div>
        <div>
          <app-text-box
            [frm]="userForm"
            formControlName="NombreUsuario"
            type="text"
            [required]="true"
            label="Usuario"
            pattern="^[aA-zZ\d\-_\s]+$"
          ></app-text-box>
        </div>
        <div *ngIf="!idUsuario">
          <app-text-box
            [frm]="userForm"
            formControlName="Password"
            type="password"
            [required]="true"
            label="Contraseña"
            pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$"
          ></app-text-box>
        </div>
        <div>
          <app-combo-box
            [frm]="userForm"
            formControlName="Idrol"
            type="role"
            [required]="true"
            label="Rol"
            classField="dropdown-rol"
          ></app-combo-box>
        </div>
        <div>
          <app-combo-box
            [frm]="userForm"
            formControlName="IdTipoIdentificacion"
            type="idType"
            [required]="true"
            label="Tipo Identificación"
            classField="dropdown-tipoID"
          ></app-combo-box>
        </div>
        <div>
          <app-text-box
            [frm]="userForm"
            formControlName="Identificacion"
            type="text"
            [required]="true"
            label="Identificación"
            (keydown)="onIdentificacionInput($event)"
            pattern="^[aA-zZ\d\s]+$"
          ></app-text-box>
        </div>
        <app-check-box
          [frm]="userForm"
          formControlName="Activo"
          label="Activo"
        ></app-check-box>
      </div>
      <br>
      
      <div class="ms-Dialog-actions" [hidden]="botonProcesando">
        <button
          type="button"
          class="ms-Button ms-Button--primary"
          (click)="clearFormUsuario()"
          style="color: white;"
        >
          Cancelar
        </button>
        <button
          type="submit"
          class="ms-Button ms-Button--primary"
          [disabled]="userForm.invalid"
        >
          <span id="btnCreateEdit" class="ms-Button-label">Crear</span>
        </button>
      </div>
    </form>
    <div class="ms-Spinner" [hidden]="!botonProcesando">
      <div class="ms-Spinner-label">
        {{ textoBotonProcesando }}
      </div>
    </div>
  </div>
</div>

<!-- Contraseña -->
<div class="docs-DialogExample-lgHeader">
  <div class="ms-Dialog ms-Dialog--lgHeader modal-contraseña" appPreventOutsideClick>
    <div id="dialogCreateEdit" class="ms-Dialog-title">Cambiar Contraseña</div>

    <form [formGroup]="passwordForm" name="passwordForm" (ngSubmit)="updatePassword()">
      <div class="ms-Dialog-content form-group">
        <div>
          <app-text-box
            [frm]="passwordForm"
            formControlName="Password"
            type="password"
            [required]="true"
            label="Contraseña"
            pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$"
          ></app-text-box>
        </div>
      </div>
      <br>
      <p>     
        <strong style="font-size: small;">Sr Usuario recuerde que la contraseña debe cumplir con las siguientes características:</strong>
      </p>
        <ul style="font-size: small;">
          <li>Longitud mínima de 8 caracteres</li>
          <li>Al menos 1 letra mayúscula</li>
          <li>Al menos 1 letra minúscula</li>
          <li>Al menos 2 números</li>
          <li>Al menos 1 caracter especial</li>
        </ul>
      <div class="ms-Dialog-actions" [hidden]="botonProcesando">
        <button type="button" class="ms-Button ms-Dialog-action" (click)="clearFormPassword()"
        >
          Cancelar
        </button>
        <button
          type="submit"
          class="ms-Button ms-Button--primary"
          [disabled]="passwordForm.invalid"
        >
          <span id="btnCreateEdit" class="ms-Button-label">Cambiar</span>
        </button>
      </div>
    </form>    
    <div class="ms-Spinner" [hidden]="!botonProcesando">
      <div class="ms-Spinner-label">
        {{ textoBotonProcesando }}
      </div>
    </div>
  </div>
</div>


<app-modal-notify #crearModal></app-modal-notify>
